import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import {
    assignSessionlist,
    getLearnSession,
    sessionNameApi
} from './api'
import {
    AssignLearnSessionPayload,
    createSessionResponse,
    InitialState,
    SessionPayload,
    sessionResponse, 
} from './types'

const initialState: InitialState = {
    sessionPayload: {
        name: ''
    },
    assignLearnSession: {
        id: '',
        courseSessionDetailDao: []
    },
    sessionresponse: {
        courseId: ''
    },
    getAllSession: [],
}

export const learnSession = createSlice({
    name: 'learnSession',
    initialState,
    reducers: {
    },
    extraReducers: {
        [sessionNameApi.fulfilled.toString()]: (
            state,
            action: PayloadAction<SessionPayload>
        ) => {
            state.sessionPayload = action?.payload
        },
        [sessionNameApi.fulfilled.toString()]: (
            state,
            action: PayloadAction<createSessionResponse>
        ) => {
            state.sessionresponse = action?.payload
        },
        [assignSessionlist.fulfilled.toString()]: (
            state,
            action: PayloadAction<AssignLearnSessionPayload>
        ) => {
            state.assignLearnSession = action?.payload
        },
        [getLearnSession.fulfilled.toString()]: (
            state,
            action: PayloadAction<Array<sessionResponse>>
        ) => {
            state.getAllSession = action?.payload
        },
    }
})

export default learnSession.reducer
